export function Article7TerBadge() {
  return (
    <span className="px-2 py-0.5 rounded-full text-[11px] font-medium whitespace-nowrap bg-violet-50 text-violet-800 border border-violet-300">
      Art. 7 ter
    </span>
  );
}
